import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { getCustomers } from 'src/selectors/customer'
import { buildPartnerNameMap } from 'src/utils/paymentsOps/partnerNames'

/** Partner id → display name from the customers slice (loaded by `PaymentsOpsLayout`). */
export const usePartnerNameMap = (): Record<string, string> => {
  const customers = useSelector(getCustomers)

  return useMemo(() => {
    return buildPartnerNameMap(customers)
  }, [customers])
}
